"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useViewport } from "@travel/shared/hooks";
import { BaseInput, Button, LinkButton, Dialog, DropDownV2, Input, NumberInput, Select, CommonText as Text, } from "@travel/shared/ui";
import ArrowIcon from "@travel/shared/assets/icons/icon-arrow-right.svg";
import styles from "./hotel-search-guest-rooms-input.module.css";
export var INITIAL_HOTEL_SEARCH_GUEST_ROOMS_INPUT_VALUE = {
    roomCount: 1,
    adultCount: 1,
    children: [],
};
export var HotelSearchGuestRoomsInput = forwardRef(function HotelSearchGuestRoomsInput(props, ref) {
    var name = props.name, _a = props.value, valueProp = _a === void 0 ? INITIAL_HOTEL_SEARCH_GUEST_ROOMS_INPUT_VALUE : _a, placeholder = props.placeholder, onChange = props.onChange;
    var _b = __read(useState(valueProp), 2), value = _b[0], setValue = _b[1];
    var _c = __read(useState(false), 2), isGroupBookingOpen = _c[0], setIsGroupBookingOpen = _c[1];
    var roomCount = value.roomCount, adultCount = value.adultCount, children = value.children;
    var childCount = value.children.length;
    var _d = __read(useState(false), 2), isFocused = _d[0], setIsFocused = _d[1];
    var _e = __read(useState(false), 2), showChildErrors = _e[0], setShowChildErrors = _e[1];
    var maxRoomOccupancy = 4;
    var totalOccupants = adultCount + childCount;
    var minAllowedRoomCount = Math.ceil(totalOccupants / maxRoomOccupancy);
    var initialValueRef = useRef(value);
    roomCount = roomCount < minAllowedRoomCount ? minAllowedRoomCount : roomCount;
    var textValue = "".concat(roomCount, " Room").concat(roomCount > 1 ? "s" : "", ", ").concat(adultCount, " Adult").concat(adultCount > 1 ? "s" : "").concat(childCount > 0 ? ", ".concat(childCount, " Child").concat(childCount > 1 ? "ren" : "") : "");
    var isSmall = useViewport().isSmall;
    useEffect(function () {
        if (isFocused) {
            initialValueRef.current = value;
        }
        else {
            setShowChildErrors(false);
        }
    }, [isFocused]);
    useEffect(function () {
        setValue(valueProp);
    }, [valueProp]);
    return (_jsxs(_Fragment, { children: [_jsx(DropDownV2, __assign({}, props, { open: isFocused, contentClassName: styles["content"], contentDesiredHeight: 280, trigger: function (state, ref, isClone) { return (_jsx(Input, __assign({}, props, { type: "button", value: textValue, error: !isClone && !state.isFocused ? props.error : undefined, forceFocused: state.isFocused, size: isSmall && isClone ? "lg" : "md", ref: ref }))); }, content: function () { return (_jsxs("div", { className: styles["main"], children: [_jsxs("div", { className: styles["inputs"], children: [_jsx(NumberInput, { label: _jsxs("div", { children: [_jsx("div", { children: "Rooms" }), _jsxs(Text, { type: "subtext", children: ["Maximum ", maxRoomOccupancy, " occupants per room"] })] }), value: roomCount, min: minAllowedRoomCount, 
                                    //max={10} @TODO: Uncomment to activate Group Bookings
                                    max: 9, onChange: handleRoomCountChange }), roomCount > 9 ? (_jsxs("div", { className: styles["group"], children: [_jsx("div", { children: "Looks like you are trying to book for a group?" }), _jsx(Button, { inline: true, size: "sm", onClick: function () {
                                                setIsGroupBookingOpen(true);
                                                setIsFocused(false);
                                            }, secondaryIcon: _jsx(ArrowIcon, {}), children: "Continue to Group Booking" })] })) : null, _jsx(NumberInput, { label: "Adults", value: adultCount, min: 1, max: 28, onChange: handleAdultCountChange }), _jsx(NumberInput, { label: "Children", value: childCount, min: 0, max: 8, onChange: handleChildCountChange })] }), value.children.length > 0 && (_jsxs(_Fragment, { children: [_jsx("ul", { className: styles["children"], children: value.children.map(function (age, index) { return (_jsx(ChildForm, { index: index, age: age, error: showChildErrors ? !age : false, onChange: handleChildFormChange }, index)); }) }), _jsx("p", { className: styles["info"], children: "To find a place to stay that fits your entire group along with correct prices, we need to know how old your children will be at check-out" })] }))] })); }, footer: _jsx(Button, { theme: "secondary", capsule: true, disabled: roomCount > 9, onClick: function () {
                        var isValid = validateHotelSearchGuestRooms(value);
                        if (isValid) {
                            setIsFocused(false);
                        }
                        else {
                            setShowChildErrors(true);
                        }
                    }, children: "Done" }), onOpenChange: function (isOpen) {
                    if (!isOpen && roomCount > 9) {
                        setValue(__assign(__assign({}, value), { roomCount: 9 }));
                    }
                    setIsFocused(isOpen);
                }, onClickClose: handleClickClose, ref: ref })), _jsx(Dialog, { open: isGroupBookingOpen, showClose: true, desiredWidth: "663px", onOpenChange: function (open) {
                    setIsGroupBookingOpen(open);
                }, content: _jsxs("div", { className: styles["groups"], children: [_jsx("div", { className: styles["title"], children: "Dedicated To Your Group Travel Needs" }), _jsx("div", { children: "Allow our talented team to set up and manage all group booking needs for your organization. Pellucid Travel is fully accredited by lATAN." }), _jsxs("div", { className: styles["content"], children: [_jsxs("div", { children: [_jsx("div", { className: styles["subtitle"], children: "Exclusive Free Membership" }), _jsxs("ul", { className: styles["list"], children: [_jsx("li", { children: "Lowest Group Rate Available" }), _jsx("li", { children: "Guaranteed Room Type" }), _jsx("li", { children: "Team/Group Friendly Hotels" }), _jsx("li", { children: "Cancellation Policy Security" }), _jsx("li", { children: "Personalized Customer Support" }), _jsx("li", { children: "Increased Revenue" }), _jsx("li", { children: "All at no cost to your team/group" }), _jsx("li", { children: "Transportation assistance available to include Group Air, Rental Cars/Vans and Motorcoach" })] })] }), _jsx("div", { className: styles["image-container"], children: _jsx("img", { className: styles["image"], src: "https://a-us.storyblok.com/f/1016730/922x502/f3ddd2bf42/fdbb073f45a6f002bb82fc9c33c8710b.png" }) })] }), _jsx("div", { className: styles["actions"], children: _jsx(LinkButton, { href: "/", external: true, inline: true, capsule: true, children: "Get An Estimate" }) })] }) })] }));
    function handleRoomCountChange(roomCount) {
        var nextValue = __assign(__assign({}, value), { roomCount: roomCount });
        setValue(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }
    function computeMinRoomCount(roomCount, adultCount, childCount) {
        var totalOccupants = adultCount + childCount;
        var minAllowedRoomCount = Math.ceil(totalOccupants / maxRoomOccupancy);
        return roomCount < minAllowedRoomCount ? minAllowedRoomCount : roomCount;
    }
    function handleAdultCountChange(adultCount) {
        var nextValue = __assign(__assign({}, value), { roomCount: computeMinRoomCount(value.roomCount, adultCount, value.children.length), adultCount: adultCount });
        setValue(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }
    function handleChildCountChange(childCount) {
        var nextChildren = [];
        for (var i = 0; i < childCount; ++i) {
            nextChildren[i] = value.children[i];
        }
        var nextValue = __assign(__assign({}, value), { roomCount: computeMinRoomCount(value.roomCount, adultCount, value.children.length), children: nextChildren });
        setValue(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }
    function handleChildFormChange(age, index) {
        var nextChildren = __spreadArray([], __read(value.children), false);
        nextChildren[index] = age;
        var nextValue = __assign(__assign({}, value), { children: nextChildren });
        setValue(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }
    function handleClickClose() {
        var _a;
        setValue(initialValueRef.current);
        (_a = props.onClickClose) === null || _a === void 0 ? void 0 : _a.call(props);
    }
});
export function validateHotelSearchGuestRooms(value) {
    var e_1, _a;
    if (value === null || value === void 0 ? void 0 : value.children) {
        try {
            for (var _b = __values(value.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (!child) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return true;
}
var CHILD_AGE_OPTIONS = __spreadArray([
    "Infant"
], __read(Array.from(new Array(17)).map(function (_, index) { return index + 1; })), false);
function ChildForm(_a) {
    var age = _a.age, index = _a.index, error = _a.error, onChange = _a.onChange;
    return (_jsxs("li", { className: styles["child-form"], children: [_jsxs("div", { children: ["Child ", index + 1] }), _jsx(BaseInput, { error: error ? "Select child age" : undefined, children: function () { return (_jsxs(Select, { value: age, onChange: function (_a) {
                        var currentTarget = _a.currentTarget;
                        return onChange(currentTarget.value, index);
                    }, children: [_jsx("option", { value: "", children: "Select Age" }), CHILD_AGE_OPTIONS.map(function (age, index) { return (_jsx("option", { value: String(age).toLowerCase(), children: index === 0 ? age : "".concat(age, " year").concat(age === 1 ? "" : "", " old") }, age)); })] })); } })] }));
}
